export default {
   translation: {
      'title': '【回収確認】',
      'action_show': '',
      'prompt_password': '',
      'error_password': '',
      'error_404': 'Not Found',
      'title_quota': 'Quota Cell',
      'title_gt': 'Grand Total Chart',
      'title_answer': 'Number of respondent',
      'title_quota_desc1': 'The number before the data cleaning',
      'title_quota_desc2': '"Target completes" includes a buffer for any bad data that may arise during data cleaning.',
      'label_gt': 'Questionnaire Section{id}',
      'answer_headers_0': '#',
      'answer_headers_1': 'Number of responses',
      'answer_headers_2': 'Number of completes',
      'quota_headers_0': 'No',
      'quota_headers_1': 'The name of Quota Cell',
      'quota_headers_2': '',
      'quota_headers_3': 'Target completes',
      'quota_headers_4': 'Current number of completes',
      'quota_headers_5': 'Remaining',
      'quota_headers_6': 'Status',
      'quota_status_0': 'Live',
      'quota_status_1': 'Closed',
      'gt_headers_0': 'Number of responses',
      'gt_headers_1': '%',
      'gt_headers_2': 'Category',
      'gt_all': 'Overall',
      'updated_at': 'Update time：',
      'update_text1': 'The number before the data cleaning',
   }
}
